<template>
  <el-dialog :visible.sync="dialogVisible" width="75%">
    <div slot="title" class="title">{{ title }}</div>

    <div class="tab-box">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ background: '#F6F6F6', color: '#606266' }"
      >
       <!-- <el-table-column
          v-for="(v, k) in tabData"
          :key="k"
          :prop="v.prop"
          :label="v.name"
        >
			<template v-if="v.solt" slot-scope="scope">{{scope.row[prop].text}}</template>
        </el-table-column> -->
		<el-table-column label="切换后点位">
			<template slot-scope="scope">{{scope.row.advertise_after.name}}(新编号:{{scope.row.advertise_after.new_number}})</template>
		</el-table-column>
		<el-table-column label="切换前点位">
			<template slot-scope="scope">{{scope.row.advertise_before.name}}(新编号:{{scope.row.advertise_before.new_number}})</template>
		</el-table-column>
		<el-table-column prop="create_time" label="切换时间"> </el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <!-- 分页 -->
      <div class="page-box" v-if="false">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 11, 12, 13]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.length"
          >&emsp;
        </el-pagination>
      </div>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default() {
        return "切换点位列表";
      },
    },
    tabData: {
      type: Array,
      default() {
        return [];
      },
    },
	tableData:{
		type: Array,
		default() {
		  return [];
		},
	}
  },
  data() {
    return {
	  type:0,
	  param:{
		id:'',
		advertise_id:'',
		new_number:''
	  },
	  order_status:'',
      dialogVisible: false,
      currentPage: 1, //当前页
      // tableData: [
      //   {
      //     date: "1",
      //     name: "王小虎",
      //     address: "上海市普陀区金沙江路 1518 弄",
      //   },
      //   {
      //     date: "2",
      //     name: "王小虎",
      //     address: "上海市普陀区金沙江路 1517 弄",
      //   },
      // ],
    };
  },
  methods: {
	handlePoint(e){
	  this.$emit('orderPoint',e)
    },
	handlePointImg(e,type){
		this.$emit('orderPointImg',{advertise_id:e,type:e,type})
	},
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-box /deep/ {
  .el-table {
    border: 1px solid #f1f3f4;
  }
  
}
/deep/ .el-dialog__body {
    padding-bottom: 0 !important;
  }
.small-btn:hover {
  opacity: 0.8 !important;
}
.small-btn:active {
  opacity: 0.9 !important;
}
</style>